import { action } from 'easy-peasy';

import { setVisitsFilter } from '~/services/localStorage/filters';
import { IActionSetVisitsFilters } from '../types';

const setVisitsFilters: IActionSetVisitsFilters = action((state, payload) => {
  setVisitsFilter(payload);

  state.filters = payload;
});

export default setVisitsFilters;
